import * as React from 'react';
export const IcBirthday = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 7h-4v2h4V7zm-2-1c.348 0 .682-.137.93-.38a1.3 1.3 0 00.38-.93 1.28 1.28 0 00-.38-.92l-.67-.66a.36.36 0 00-.52 0l-.67.66a1.28 1.28 0 00-.38.92 1.301 1.301 0 00.38.93c.248.243.582.38.93.38zm-4.5 9a2.11 2.11 0 001.58-.75 4 4 0 015.83 0 1.999 1.999 0 003.17 0A4.44 4.44 0 0120 13.12V12a2 2 0 00-2-2H6a2 2 0 00-2 2v1.12a4.5 4.5 0 011.91 1.13A2.12 2.12 0 007.5 15zM20 19v-3.72c-.207.143-.404.3-.59.47a4 4 0 01-5.83 0 2 2 0 00-3.17 0 4 4 0 01-5.83 0 4.303 4.303 0 00-.58-.46V19a1 1 0 000 2h16a1 1 0 100-2z'
      fill='currentColor'
    />
  </svg>
);
